import { fmtDate } from "@/lib/utils";
import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, Loader2 } from "lucide-react";

export const CancelModal = ({ booking, onClose, onDone }) => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/bookings/${booking.id}/cancel-info`).then((r) => setInfo(r.data)).catch(() => setInfo({ allowed: false }));
  }, [booking.id]);

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/bookings/${booking.id}/cancel`);
      toast.success(data.refund?.status === "refunded" ? `Storniert – ${data.refund.amount} € werden zurückerstattet.` : "Buchung storniert.");
      onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); setBusy(false); }
  };

  const days = info?.hours_until_departure != null ? Math.floor(info.hours_until_departure / 24) : null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" data-testid="cancel-modal">
      <div className="eb-card p-6 w-full max-w-md">
        <h3 className="font-head text-xl font-semibold flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-400" /> Buchung stornieren</h3>
        <p className="text-sm text-slate-400 mt-1">{booking.route_label} · Abfahrt {fmtDate(booking.abfahrt)}</p>
        {!info ? <div className="py-6 text-slate-400 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Prüfe Stornierungsfrist…</div> : (
          <div className="mt-4 rounded-lg border border-slate-800 bg-[#0B0F17] p-4 text-sm space-y-1.5" data-testid="cancel-info">
            <div className="flex justify-between"><span className="text-slate-400">Frist</span><span>bis {info.deadline_hours} h (5 Tage) vor Abfahrt</span></div>
            {days != null && <div className="flex justify-between"><span className="text-slate-400">Bis zur Abfahrt</span><span>{days} Tage</span></div>}
            <div className="flex justify-between"><span className="text-slate-400">Rückerstattung</span><span className="mono text-emerald-400">{info.refund_amount} €</span></div>
            {!info.allowed && <p className="text-red-300 pt-2" data-testid="cancel-not-allowed">Eine kostenfreie Stornierung ist nur bis 120 Stunden vor Abfahrt möglich.</p>}
          </div>
        )}
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="eb-btn-outline" data-testid="cancel-close-btn">Abbrechen</button>
          <button onClick={confirm} disabled={!info?.allowed || busy} className="eb-btn-primary !bg-red-600 hover:!bg-red-500" data-testid="cancel-confirm-btn">
            {busy ? "Storniere…" : "Verbindlich stornieren"}
          </button>
        </div>
      </div>
    </div>
  );
};
